import React, { useEffect } from 'react'
import { SchemaManager, ISettings } from '../schemamanager/schemaManager'
import { ISchema } from '../schemamanager/types'
import { Item } from './item'

interface Props {
  schema?: ISchema
  values?: any
  settings?: ISettings
  schemaManager?: SchemaManager
}

export const VsForm = (props: Props) => {

  let schemaManager: SchemaManager

  useEffect(() => {
    if (schemaManager.Schema.onMount) {
      schemaManager.Schema.onMount({ sm: schemaManager, comp: schemaManager.Schema })
    }
    return () => {
      if (schemaManager.Schema.onUnMount) {
        schemaManager.Schema.onUnMount({ sm: schemaManager, comp: schemaManager.Schema })
      }
    }
  }, [props.schema])
  
  if (props.schemaManager) {
    if (!props.schemaManager.Schema) {
      return <h2>Error in vs-form, no Schema for SchemaManager defined!</h2>
    }
    schemaManager = props.schemaManager
  } else {
    if (props.schema) {
      schemaManager = new SchemaManager(props.settings)
      schemaManager.InitSchema(props.schema)
      if (props.values) {
        schemaManager.InitValues(props.values)
      }
    } else {
      return <h2>Error in vs-form, no Schema defined</h2>
    }
  }

  return <Item sm={schemaManager} comp={schemaManager.Schema} />
}
